export default "__VITE_ASSET__41b2bdf4__"